import React from 'react';

import {
  Redirect,
} from 'react-router-dom';

import HtmlHead from 'components/html-head/HtmlHead';

import {
  GetStaffPortalStore,
} from 'SessionState/Staff/StaffPortalStore';

type StaffPortalShellProps = {
  title: string;
  description: string;
  children: React.ReactNode;
};

const StaffPortalShell: React.FC<
  StaffPortalShellProps
> = ({
  title,
  description,
  children,
}) => {
  const staffStore =
    GetStaffPortalStore();

  const currentTabulator =
    staffStore.CurrentTabulator;

  if (
    !currentTabulator ||
    !currentTabulator.pageantId
  ) {
    return (
      <Redirect
        to="/staff/login"
      />
    );
  }

  return (
    <>
      <HtmlHead
        title={title}
        description={description}
         image="/img/background/HT_StaffPortal.png"
      />

      {children}
    </>
  );
};

export default StaffPortalShell;